const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
      api: "https://vsip-api.vietnamiz.com/",
      domainUserSide: "http://localhost:3000",
      domainAdminSide: "http://localhost:3001",
      domainName: "localhost",
      doMainNameGeoServer: "https://geo.cgis.asia/geoserver/wfs",
      doMainNameGeoServerWMS: "https://geo.cgis.asia/geoserver/wms",
  },
  production: {
      api: "https://vsip-api.vietnamiz.com/",
      domainUserSide: "https://vsip.vietnamiz.com",
      domainAdminSide: "https://admin.vsip.vietnamiz.com",
      domainName: "vsip.vietnamiz.com",
      doMainNameGeoServer: "https://geo.cgis.asia/geoserver/wfs",
      doMainNameGeoServerWMS: "https://geo.cgis.asia/geoserver/wms",
  },
};

module.exports = apiEnvironment[env];
